import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector,useDispatch } from "react-redux";
import "./shortcuts.css";


//utils
import { shortcuts } from "./utils";

//components
import Card from "./subcomponents/card/card";
import FlipCard from "./subcomponents/flipcard/card";

//actions
import { setBlinkRequest } from '../../../reducer/clientsSlice';

export default function ShortCuts() {



    const dispatch = useDispatch();
    const navigate = useNavigate();

 const { is_starter, id } = useSelector(
    (state) => state.user.user
  );
    const isStarterClient = Number(is_starter) === 1;

    // Opens the starter client walkthrough video (served by the backend) in a new tab
    const openStarterTrainingVideo = () => {
        if (!id) return;
        const url = `${process.env.REACT_APP_API_URL_EXPORT}starter-training-video/${id}`;
        window.open(url, "_blank", "noopener,noreferrer");
    };
    useEffect(() => {
        let redirect_to = localStorage.getItem("redirect_to")
        if (redirect_to === "starter-booking") {
            navigate('/appointment')
        }

    }, [])

    const onClickCardHandler = (item) => {
        if (item.id === 1) {
            findMeetingLink(item.url);
        } else if (item.id === 2) {
            cancelBooking(item.url);
        } else if (item.id === 3) {
            giveFeedBack(item.url);
        } else if (item.id === 4) {
            payMedium(item.url);
        } else if (item.id === 5) {
            bookSession(item.url);
        }
    };

    const findMeetingLink = (url) => {
        dispatch(setBlinkRequest('meetinglink'))
        navigate(url);
    };

    const cancelBooking = (url) => {
        dispatch(setBlinkRequest('cancelbooking'))
        navigate(url);
    };
    const giveFeedBack = (url) => {
        dispatch(setBlinkRequest('givefeedback'))
        navigate(url);
    };
    const payMedium = (url) => {
        dispatch(setBlinkRequest('paymedium'))
        navigate(url);
    };
    const bookSession = (url) => {
        navigate(url);
    };
     const onClickCardHandlerFlip = (item) => {
  const url = "https://buy.stripe.com/bIY2884XR4oDck86oo?locale=en&__embed_source=buy_btn_1RNv5VHzWXOgYzHHpJUIIiKN";
  
  window.open(url, "_blank", "noopener,noreferrer");
};
    return (
        <>
            <div className="dashboard client-shortcuts-page">
                <div className="row">
                    <div className="col-md-12">
                        <div className="quck-box">
                            <div className="shortcuts-header-row">
                                <h2>Quick Shortcuts</h2>
                                {isStarterClient && (
                                    <button
                                        type="button"
                                        className="starter-training-video-btn"
                                        onClick={openStarterTrainingVideo}
                                    >
                                        <span className="starter-training-video-btn-icon" aria-hidden="true">
                                            <svg width="12" height="12" viewBox="0 0 12 12" focusable="false">
                                                <path d="M3 1.5v9a.5.5 0 0 0 .77.42l7-4.5a.5.5 0 0 0 0-.84l-7-4.5A.5.5 0 0 0 3 1.5z" fill="currentColor" />
                                            </svg>
                                        </span>
                                        Welcome to VerySoul: Starter Client Volunteer Guide
                                    </button>
                                )}
                            </div>

                            <div className="quick-status-two client-dashboard-card-wrapper">
                                {shortcuts.map((item) => (
                                    <>
                                        <FlipCard
                                            type={item.type}
                                            src={item.src}
                                            alt={item.alt}
                                            title={item.title}
                                            onclick={() => onClickCardHandler(item)}
                                            url={item.url}
                                        />
                                    </>
                                ))}
                               
                                 <>
                                        <FlipCard
                                            type="card"
                                            src="./clientdashboardimages/download.svg"
                                            alt="card"
                                            title="Help Fund Others"
                                            onclick={() => onClickCardHandlerFlip()}
                                            url="#"
                                        />
                                    </>
      
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>

    );
}
